import { render } from "./ModalDocumentCreateComplete.vue?vue&type=template&id=efaec08c&scoped=true"
import script from "./ModalDocumentCreateComplete.vue?vue&type=script&lang=js"
export * from "./ModalDocumentCreateComplete.vue?vue&type=script&lang=js"

import "./ModalDocumentCreateComplete.vue?vue&type=style&index=0&id=efaec08c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efaec08c"]])

export default __exports__